var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import { IconSvg } from "../../IconSvg";
import styled from "styled-components";
import { media } from "../../../const/media";
export var StyledLink = styled.a(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  min-height: 3.125rem;\n  text-decoration: none;\n  font-size: 0.875rem;\n  line-height: 1.2;\n  background-color: #f8f8f8;\n  border-radius: 0.625rem;\n  border: none;\n  cursor: pointer;\n  color: black;\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  position: relative;\n  max-width: 9.125rem;\n  width: 100%;\n  margin: 0 1.5rem 0 auto;\n  padding: 0.5rem 1.125rem;\n  padding-left: 1rem;\n  @media ",
      " {\n    max-width: 3rem;\n    padding: 0.5rem;\n    margin-right: 1rem;\n  }\n",
    ])),
  media.desktop1200
);
export var StyledText = styled.span(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteralLoose([
      "\n  flex-shrink: 0;\n\n  @media ",
      " {\n    display: none;\n  }\n",
    ])),
  media.desktop1200
);
export var StyledIcon = styled(IconSvg)(
  _templateObject3 ||
    (_templateObject3 = _taggedTemplateLiteralLoose([
      "\n  flex-shrink: 0;\n  margin-right: 0.75rem;\n  width: 1.125rem;\n  @media ",
      " {\n    margin-right: 0;\n  }\n",
    ])),
  media.desktop1200
);
